import { useEffect, useRef, useState } from "react";
// GRAPE JS
import grapesjs from "grapesjs";
import customCodePlugin from "layouts/pages/utils/custom-code-grapejs/index.ts";
import gjsTabs from "layouts/pages/utils/grapeJsTabs/index";
import gjsImageEditor from "layouts/pages/utils/grapeJsImageEditor/index.ts";
import gjsTooltip from "grapesjs-tooltip";
import gjsp from "grapesjs-preset-webpage";
import gjsModal from "layouts/pages/utils/grapejsModal/index.ts";
import gjsAccordian from "grapesjs-accordion";
//import gjsTuiImageEditor from "grapesjs-tui-image-editor";
import alignment from "layouts/pages/customstyles/alignment.js";
import myNewComponentTypes from "./components/grapejscomponents/index.ts";
import placeholder from "layouts/pages/utils/grapesJSPlaceholder/index.js";
import { utils } from "./utils/index";
import MDInput from "components/MDInput";
import client from "ApiClient";
import { useNavigate } from "react-router-dom";
import MDButton from "components/MDButton";
import Autocomplete from "@mui/material/Autocomplete";
import { useSearchParams } from "react-router-dom";
import { Card, Checkbox, CircularProgress, FormControlLabel } from "@material-ui/core";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import MDTypography from "components/MDTypography";
import { updateBlocks } from "./blocks/updateblocks";
import { newBlocks } from "./blocks/newblocks";
import { sidebarPannel } from "./panels/sidebarpanel";
import { grapeJsEvents } from "./events/grapeJsEvents";
import { SendPadForm } from "./components/sendPadForm";
import { ExpandText } from "./components/expandText";
import { ImageAI } from "./components/imageAI";
import { useMaterialUIController } from "context";
import Settingsidebar from "./panels/settingsidebar";
import MDSnackbar from "components/MDSnackbar";
import { CardHeader } from "reactstrap";
import { setHideSidenav } from "context/index.js";
import ConfirmationAlert from "components/ConfirmationAlert/index.js";
import tiny_mce from "./tiny_mce/index.js";
import Templates from "layouts/funnels/components/templates.js";
import replaceTextViewComponent from "./utils/single-click-tinymce/index.js";
import MDBox from "components/MDBox/index.js";
import { ExpandHeading } from "./components/expandHeading.js";
import { position } from "stylis";
//import ".//grapejs_v1.scss";

/* eslint-disable */
export default function AddV2() {
  const [OpenConfirmationClose, setOpenConfirmationClose] = useState(false);
  const [settingSidebarOpen, setSettingSidebarOpen] = useState(false);
  const [savingOpen, setSavingOpen] = useState(false);
  const [openPageName, setOpenPageName] = useState(false);
  const [publishOnRoot, setPublishOnRoot] = useState(false);
  const [grapeEditor, setGrapeEditor] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingText, setLoadingText] = useState("");
  const [page, setPage] = useState(null);
  const [pageTitle, setPageTitle] = useState("");
  const [pageName, setPageName] = useState("");
  const [faviconUrl, setFaviconUrl] = useState("");
  const [bgImageUrl, setBgImageUrl] = useState("");
  const [pagKeywords, setPagKeywords] = useState("");
  const [pagSlug, setPagSlug] = useState("");
  const [pagDescription, setPagDescription] = useState("");
  const [pagGoogleConversionID, setPagGoogleConversionID] = useState("");
  const [pagGoogleConversionLabel, setPagGoogleConversionLabel] = useState("");
  const [pagGoogleMetaTag, setPagGoogleMetaTag] = useState("");
  const [pagGoogleAnalyticsID, setPagGoogleAnalyticsID] = useState("");
  const [pagMSVerificationTag, setPagMSVerificationTag] = useState("");
  const [pagMSUETTagID, setPagMSUETTagID] = useState("");
  const [pagCustomHead, setPagCustomHead] = useState("");
  const [pagCustomBody, setPagCustomBody] = useState("");
  const [pagCustomFooter, setPagCustomFooter] = useState("");
  const [domains, setDomains] = useState([]);
  const [sendpadForms, setSendpadForms] = useState(null);

  const [selectedDomain, setSelectedDomain] = useState(process.env.REACT_APP_MAIN_DOMAIN);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [openTemplates, setOpenTemplates] = useState(false);
  const [images, setImages] = useState(null);

  const [controller, dispatch] = useMaterialUIController();
  const [openSettingSaved, setOpenSettingSaved] = useState(false);
  const closeSettingSaved = () => setOpenSettingSaved(false);
  const [checkSaving, setCheckSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [publishOpen, setPublishOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(true);

  const account = JSON.parse(localStorage.getItem("account"));
  const id = searchParams.get("id");
  const editorPanel = useRef(null);
  const optionsPanel = useRef(null);

  useEffect(() => {
    // Conditionally import SCSS file based on your condition
    const importScss = async () => {
      const scssModule = await import(".//grapejs_v1.scss");
      return scssModule.default;
    };

    let linkTag;

    importScss().then((scssHref) => {
      linkTag = document.createElement("link");
      linkTag.rel = "stylesheet";
      linkTag.type = "text/css";
      linkTag.href = scssHref;
      document.head.appendChild(linkTag);
    });

    setHideSidenav(dispatch, true);

    if (
      JSON.parse(localStorage.getItem("settings")).set_msApiKey != "" &&
      JSON.parse(localStorage.getItem("settings")).set_msApiKey != null
    )
      getFroms();

    getDomains();
    return () => {
      setHideSidenav(dispatch, false);
      if (linkTag) {
        document.head.removeChild(linkTag);
      }
      setImages(null);
    };
  }, []);

  const options = {
    method: "GET",
    url: "pages",
    headers: {
      "content-type": "application/json",
    },
  };

  const getDomains = async () => {
    options.method = "GET";
    options.url = `domains`;
    await client
      .request(options)
      .then((response) => {
        const domains = response.filter((f) => f.dom_status == 0).map((d) => d.dom_domain);
        domains.push(process.env.REACT_APP_MAIN_DOMAIN);
        setDomains(domains);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getFroms = async () => {
    options.method = "GET";
    options.url = `forms`;
    await client
      .request(options)
      .then((response) => {
        let form = [];
        if (response.error_message != "Invalid API key") {
          response.map((item) => {
            form.push({
              id: item.name,
              name: item.name,
              value: item.html,
            });
          });
        }
        setSendpadForms(form);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getImages = async () => {
    if (grapeEditor == null) return;
    options.method = "GET";
    options.url = `grapeai/getImages`;
    await client
      .request(options)
      .then((response) => {
        setImages(response);
        grapeEditor.AssetManager.add(response);
        setIsSaving(false);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteImages = async (image) => {
    options.method = "DELETE";
    options.url = `grapeai?ima_id=${image.id}`;

    await client
      .request(options)
      .then((response) => {
        //  console.log(response);
        // getImages();
        // return response;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("settings")).set_msApiKey != "" &&
      JSON.parse(localStorage.getItem("settings")).set_msApiKey != null &&
      sendpadForms == null
    )
      return;

    const plugins = [
      gjsAccordian,
      //gjsTuiImageEditor, //
      gjsImageEditor,
      gjsp,
      gjsTabs,
      gjsTooltip,
      gjsModal,
      ImageAI,
      ExpandText,
      ExpandHeading,
      alignment,
      customCodePlugin,
      tiny_mce,
      placeholder,
      myNewComponentTypes,
    ];

    if (sendpadForms != null && sendpadForms.length > 0) plugins.push(SendPadForm);

    const editor = grapesjs.init({
      allowScripts: 1,
      modal: {
        backdrop: false,
      },
      storageManager: {
        type: "local", // Storage type. Available: local | remote
        autosave: false, // Store data automatically
        autoload: false, // Autoload stored data on init
        stepsBeforeSave: 1, // If autosave is enabled, indicates how many changes are necessary before the store method is triggered
      },
      container: "#gjs",
      height: "100vh",
      fromElement: true,
      storageManager: false,
      styleManager: {
        sectors: [
          // {
          //     name: "Resizing",
          //     properties: [
          //       {
          //         type: "my-custom",
          //          property: "text-align",
          //         default: "center",
          //         // min: 10,
          //         // max: 70,
          //       },
          //     ],
          //   },
          {
            name: "Dimension",
            open: false,
            properties: ["width", "height", "max-width", "min-height", "margin", "padding"],
          },
          {
            name: "Flex",
            open: false,
            properties: [
              "flex-direction",
              "flex-wrap",
              "justify-content",
              "align-items",
              "align-content",
              "order",
              "flex-basis",
              "flex-grow",
              "flex-shrink",
              "align-self",
            ],
          },
          {
            name: "Alignment",
            properties: [
              {
                type: "my-custom-prop",
                property: "text-align",
                default: "center",
                // min: 10,
                // max: 70,
              },
            ],
          },
        ],
      },
      canvasCss: `
      .button{
              border:0 solid white;
              padding:3px 5px 3px 5px;
              margin:0 0 0 10px;
              background-color:#0d63cb;
            }
          gjs-plh-image{
              color:#3b97e3;
          }
          .image-pl-svg{
              fill:#3b97e3;
          }
          .gjs-plh-image[data-gjs-type="image"]{
              width:30%;
              height:30%;
              background-color:transparent;
              outline:none;
  
          }
        
          div.navbar[data-gjs="navbar"]{
              max-width:100%;
  
          }
          div.navbar[data-gjs="navbar"]>.navbar-container{
              max-width:1140px;
          }
         
  
          .gjs-selected{
              outline: 4px solid #3b97e3 !important;
              outline-offset: -2px;
          }
          .gjs-mdl-dialog {
            background-color: #FFF;
          }
          img.gjs-selected{
              z-index: 90000001;
              position: relative;
          }
          .gjs-higlight-backdrop-container{
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #151515;
              z-index:9000000;
              opacity:0;
              transition: opacity 0.3s ease-in
          }
          .gjs-higlight-backdrop-container.active{
              opacity:0.3;
          }
  
          .form-group {
              width: 100%;
          }
  
          .form-group {
              width: 100%;
          }
          [data-gjs-type="grid-item"]:empty {
              overflow: hidden;
              text-decoration: none;
              padding: 5px;
              display: flow;
      width: 99%;
          }
          .cell{
            height: auto !important;
          }
          [data-gjs-type="grid-item"]:empty:before {
              background-color: #ddd;
              color: #000;
              font-size: 16px;
              font-weight: bold;
              height: 75px;
              display: flex;
              align-items: center;
              justify-content: center;
              min-height: 50px;
              padding: 0 10px;
              opacity: 0.3;
              border-radius: 3px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              content: "Column";
          }   
          .gjs-row,.row{display:flex;justify-content:flex-start;align-items:stretch;flex-wrap:nowrap;padding:10px;min-height:75px;flex-direction:row}@media (max-width:768px){.gjs-row,.row{flex-wrap:wrap; flex-direction: column;gap: 10px;}}.cell,.cell-gut,.gjs-cell,.gjs-cell-gut{flex-grow:1;flex-basis:100%;padding:5px}.cell-gut,.gjs-cell-gut{padding-right:15px}@media (max-width:768px){.cell-gut,.gjs-cell-gut{padding-right:0}}@media (max-width:768px){.burger{display:block}}
  
        `,
      protectedCss: `a:link { 
  text-decoration: none; 
} body{margin:0; }.row{margin:0 auto;box-sizing:border-box;} div.row>div.cell:first-child{
              padding-right:6px;
              padding-left:0px;
          }div.row>div.cell:last-child{
              padding-left:6px;
              padding-right:0px;
          }div.cell{
              padding-left:3px;
              padding-right:3px;
          } 
          .cell{
            height: auto !important;
          }
          .right-space-issue {
    margin-right: 3rem;
  } @media (max-width: 768px){       .right-space-issue {
    margin-right: 0;
  }}
          .openModalBtn{border: none; cursor: pointer; background-color: #f0c864; color: #000;font-weight: 700; line-height: 1.66; font-size: 20px; border: 0; border-radius: 30px; display: inline-block; padding: 8px 20px; width: auto; height: 48px;} .modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;} a.accordion::before{content: '+';margin-right: 8px;}.accordion-active a.accordion::before {content: '–';}img{max-width:100%;height:auto}.cell {height: auto;vertical-align: top;}.cke_editable p{display: block; margin-block-start: 0em !important; margin-block-end: 0em !important;margin-inline-start: 0em !important;margin-inline-end: 0em !important;}table.grid-item-card tbody tr td {background: none !important;}.list-item tr td {background: none !important;}.form-group{ float:none; flex-direction:column; border:0 solid black; display:flex; } .label{ margin:0 0 15px 0; font-family:Arial, Helvetica, sans-serif; font-size:14px; font-weight:600; } .form{ display:flex; flex-direction:column; padding:50px 50px 50px 50px; border:1px solid #6c7978; margin:10px 10px 10px 10px; background-color:#f5f5f5; } .input{ height:40px; width:auto; margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px; } textarea { margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px;} .button{ height:42px; border-radius:7px; margin:10px 0 0 0; border:1px solid #7e7e7e; font-family:Arial Black, Gadget, sans-serif; font-size:14px; font-weight:600; color:#ffffff; background-color:#000000; } .form-group:nth-child(3) {display: none;} .form-group:nth-child(4) {display: none;}.form-group:has(> .checkbox) { flex-direction:row;align-items: start; }input.checkbox {margin-left: 25px;}label.checkbox-label {margin-left: 5px;} @media (max-width: 992px){ .form{ padding:20px 20px 20px 20px; } }@media (max-width:768px){.cell{width:100%;}div.row>div.cell:first-child{
              padding-right:0px;
              padding-left:0px;
          }div.row>div.cell:last-child{
              padding-left:0px;
              padding-right:0px;
          } }
          .form-group {
              width: 100%;
          }
          .gjs-row,.row{display:flex;justify-content:flex-start;align-items:stretch;flex-wrap:nowrap;padding:10px;min-height:75px;flex-direction:row}@media (max-width:768px){.gjs-row,.row{flex-wrap:wrap; flex-direction: column;gap: 10px;}}.cell,.cell-gut,.gjs-cell,.gjs-cell-gut{flex-grow:1;flex-basis:100%;padding:5px}.cell-gut,.gjs-cell-gut{padding-right:15px}@media (max-width:768px){.cell-gut,.gjs-cell-gut{padding-right:0}}@media (max-width:768px){.burger{display:block}}
        .modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;}a.accordion::before{content: '+';margin-right: 8px;}.accordion-active a.accordion::before {content: '–';}.row{padding:0 !important;}p{padding:0 !important; margin:0 !important;}h1{padding:0 !important; margin:0 !important;}h4{padding:0; margin:0;}@media(max-width:768px){.cell{display: block !important; width: 100% !important; height: auto !important; padding: 0 !important; min-height: 75px !important; }}.accordion>p{display:inline-block;}           
         `,
      width: "100%",
      plugins: plugins,
      pluginsOpts: {
        [gjsp]: {
          blocks: [],
          showStylesOnChange: false,
          // options
        },
        [tiny_mce]: {
          "tinymce-module": "/tinymce/tinymce.min.js",
          inline: ["span", "a", "button"],
          inline_toolbar: [
            "bold italic underline strikethrough forecolor | alignleft aligncenter alignright alignfull",
          ],
          toolbar: [
            "bold italic underline strikethrough link outdent indent",
            "blocks forecolor backcolor | alignleft aligncenter alignright alignfull | numlist bullist",
          ],
          plugins: ["link", "lists", "autolink"],
        },
        customCodePlugin: {
          placeholderScript: true,
          blockCustomCode: { label: "Custom" },
          // options
        },
        [placeholder]: {
          dragDefault: [""],
          dragClasses: ["gjs-selected", "gjs-freezed", "animation"],
          animation: ["none"], // animation1 / animation2 / animation3 / animation4 / animation5 / none
        },
        [SendPadForm]: {
          forms: sendpadForms,
        },
      },
      clearOnRender: true,

      deviceManager: {
        devices: [
          {
            id: "desktop",
            name: "Desktop",
            width: "",
          },
          {
            id: "tablet",
            name: "Tablet",
            width: "768px",
            widthMedia: "992px",
          },
          {
            id: "mobilePortrait",
            name: "Mobile portrait",
            title: "Mobile portrait",
            width: "320px",
            widthMedia: "575px",
          },
        ],
      },
      assetManager: {
        custom: false,
        upload: process.env.REACT_APP_API_BASE_URL + "/grapeai/uploadImageBin",
        multiUpload: false,
        headers: { Authorization: JSON.parse(localStorage.getItem("AuthorizationToken")) },
        autoAdd: 1,
      },
    });

    newBlocks(editor);

    editor.on("load", () => {
      updateBlocks(editor);
      if (id) {
        options.method = "GET";
        options.url = `pages/byid?page_id=${id}`;
        client
          .request(options)
          .then((response) => {
            setPage(response);

            setPageTitle(response.pag_title);
            setFaviconUrl(response.pag_favicon);
            setPagSlug(response.pag_slug);
            setBgImageUrl(response.pag_bg_image);
            setPagKeywords(response.pag_keywords);
            setPagDescription(response.pag_description);
            setPagGoogleConversionID(response.pag_googleConversionID);
            setPagGoogleConversionLabel(response.pag_googleConversionLabel);
            setPagGoogleMetaTag(response.pag_googleMetaTag);
            setPagGoogleAnalyticsID(response.pag_googleAnalyticsID);
            setPagMSVerificationTag(response.pag_MSVerificationTag);
            setPagMSUETTagID(response.pag_MSUETTagID);
            setPagCustomHead(response.pag_customHead);
            setPagCustomBody(response.pag_customBody);
            setPagCustomFooter(response.pag_customFooter);

            const publishButton = panelManager.getButton("myNewPanel", "publish");
            publishButton.set(
              "label",
              `<button type="button"  class="ccc btn btn-secondary Mydropdowntoogle" style="background-color: green;cursor:pointer"> 
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="11" width="11" xmlns="http://www.w3.org/2000/svg">
                        <path d="M477.64 38.26a4.75 4.75 0 00-3.55-3.66c-58.57-14.32-193.9 36.71-267.22 110a317 317 0 00-35.63 42.1c-22.61-2-45.22-.33-64.49 8.07C52.38 218.7 36.55 281.14 32.14 308a9.64 9.64 0 0010.55 11.2l87.31-9.63a194.1 194.1 0 001.19 19.7 19.53 19.53 0 005.7 12L170.7 375a19.59 19.59 0 0012 5.7 193.53 193.53 0 0019.59 1.19l-9.58 87.2a9.65 9.65 0 0011.2 10.55c26.81-4.3 89.36-20.13 113.15-74.5 8.4-19.27 10.12-41.77 8.18-64.27a317.66 317.66 0 0042.21-35.64C441 232.05 491.74 99.74 477.64 38.26zM294.07 217.93a48 48 0 1167.86 0 47.95 47.95 0 01-67.86 0z"></path>
                        <path d="M168.4 399.43c-5.48 5.49-14.27 7.63-24.85 9.46-23.77 4.05-44.76-16.49-40.49-40.52 1.63-9.11 6.45-21.88 9.45-24.88a4.37 4.37 0 00-3.65-7.45 60 60 0 00-35.13 17.12C50.22 376.69 48 464 48 464s87.36-2.22 110.87-25.75A59.69 59.69 0 00176 403.09c.37-4.18-4.72-6.67-7.6-3.66z"></path>
                    </svg>
                    <span class="px-2 fw-semibold"> ${
                      draftLoading
                        ? "loading"
                        : response.pag_status == 3
                        ? "Publish"
                        : "Change domain"
                    }
                    <span>                
                    </span> 
                    </span>
                </button>
            `
            );
            if (response.pag_json != "") editor.loadProjectData(JSON.parse(response.pag_json));
            else setOpenTemplates(true);

            editor.UndoManager.clear();
            setHasChanges(false);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        editor.setComponents("");
      }
    });

    const panelManager = editor.Panels;

    editor.on("asset:remove", (asset) => {
      deleteImages(asset.attributes);
      getImages();
    });

    // editor.on('asset', ({ event, model }) => {console.log('asset', event, model);});

    //  editor.on('asset:upload:end', (result) => { console.log('asset:upload:end', result); console.log('asset:upload:end', this); });

    /*
    editor.on("asset:add", (asset) => {
      console.log("asset", asset);
     // const am = editor.AssetManager;
     // am.add(asset);
      //deleteImages(asset.attributes);
      //getImages();
    });
*/

    editor.on("asset", ({ event, model }) => {
      /*
      const am = editor.AssetManager;
      if (model?.data) {
        am.add(model?.data);
      }
        */
      // getImages();
    });

    editor.on("change:changesCount", (model) => {
      setHasChanges(true);
    });

    editor.on("modal:open", (asset) => {
      editorPanel.current = panelManager.getPanel("myNewPanel");
      optionsPanel.current = panelManager.getPanel("options");
      panelManager.removePanel("options");
      panelManager.removePanel("myNewPanel");
    });

    editor.on("modal:close", (asset) => {
      panelManager.addPanel(optionsPanel.current);
      panelManager.addPanel(editorPanel.current);
    });

    editor.Panels.removeButton("options", "undo");
    editor.Panels.removeButton("options", "redo");
    panelManager.addButton("options", [
      {
        id: "undo",
        className: "fa fa-undo icon-undo",
        command: function (editor, sender) {
          //console.log("sender", sender);
          if (editor.UndoManager.hasUndo()) {
            editor.UndoManager.undo();
            //sender.set("active", 0);
          }
        },
        attributes: {
          title: "Undo (CTRL/CMD + Z)",
        },
      },
      {
        id: "redo",
        className: "fa fa-repeat icon-redo",
        command: function (editor, sender) {
          //console.log("hasRedo", editor.UndoManager.hasRedo());
          if (editor.UndoManager.hasRedo()) {
            editor.UndoManager.redo();
            // sender.set("active", 0);
          }
        },
        attributes: {
          title: "Redo (CTRL/CMD + Y)",
        },
      },
    ]);

    panelManager.addPanel({
      id: "myNewPanel",
      buttons: [
        {
          id: "logo",
          className: "logo-editor",
          label: `<img src="https://thumbs.${process.env.REACT_APP_MAIN_DOMAIN}/images/pixapage-logot.png" alt="Logo" height="40">`,
        },
        {
          id: "backbtn",
          disabled: isSaving,
          command: {
            run: () => {
              setCheckSaving(true);
            },
          },
          className: " btnBack",
          label: `<button   class="ccc btn btn-secondary Mydropdowntoogle" style="color:#333;background-color: #FFF;cursor:pointer"> 
          <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
     <span class="px-2 fw-semibold"> ${draftLoading ? "loading" : "Close"}  <span>                
      </span> </span>
       </button>
  `,
        },
        {
          id: "savebtn",
          disabled: isSaving,
          command: {
            run: async () => {
              setSavingOpen(true);
            },
          },
          className: "fa-solid fa-floppy-disk",
          label: `<button   class="ccc btn btn-secondary Mydropdowntoogle" style="background-color: green;cursor:pointer"> 
                    <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M840-680v480q0 33-23.5 56.5T760-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h480l160 160Zm-80 34L646-760H200v560h560v-446ZM480-240q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM240-560h360v-160H240v160Zm-40-86v446-560 114Z"/></svg>
               <span class="px-2 fw-semibold"> ${
                 draftLoading ? "loading" : "Save"
               }  <span>                
                </span> </span>
                 </button>
            `,
        },
        {
          id: "publish",
          label: `<button type="button"  class="ccc btn btn-secondary Mydropdowntoogle" style="background-color: green;cursor:pointer"> 
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="11" width="11" xmlns="http://www.w3.org/2000/svg">
                        <path d="M477.64 38.26a4.75 4.75 0 00-3.55-3.66c-58.57-14.32-193.9 36.71-267.22 110a317 317 0 00-35.63 42.1c-22.61-2-45.22-.33-64.49 8.07C52.38 218.7 36.55 281.14 32.14 308a9.64 9.64 0 0010.55 11.2l87.31-9.63a194.1 194.1 0 001.19 19.7 19.53 19.53 0 005.7 12L170.7 375a19.59 19.59 0 0012 5.7 193.53 193.53 0 0019.59 1.19l-9.58 87.2a9.65 9.65 0 0011.2 10.55c26.81-4.3 89.36-20.13 113.15-74.5 8.4-19.27 10.12-41.77 8.18-64.27a317.66 317.66 0 0042.21-35.64C441 232.05 491.74 99.74 477.64 38.26zM294.07 217.93a48 48 0 1167.86 0 47.95 47.95 0 01-67.86 0z"></path>
                        <path d="M168.4 399.43c-5.48 5.49-14.27 7.63-24.85 9.46-23.77 4.05-44.76-16.49-40.49-40.52 1.63-9.11 6.45-21.88 9.45-24.88a4.37 4.37 0 00-3.65-7.45 60 60 0 00-35.13 17.12C50.22 376.69 48 464 48 464s87.36-2.22 110.87-25.75A59.69 59.69 0 00176 403.09c.37-4.18-4.72-6.67-7.6-3.66z"></path>
                    </svg>
               <span class="px-2 fw-semibold"> ${
                 draftLoading ? "loading" : page?.pag_status == 3 ? "Publish" : "Change domain"
               }  <span>                
                </span> </span>
                 </button>
            `,
          disabled: isSaving,
          command: {
            run: () => {
              setPublishOpen(true);
            },
          },
        },
        {
          id: "cmdDeviceDesktop",
          command: (e) => e.setDevice("Desktop"),
          className: "fa fa-desktop",
          active: 1,
        },
        {
          id: "cmdDeviceTablet",
          command: (e) => e.setDevice("Tablet"),
          className: "fa fa-tablet",
        },
        {
          id: "cmdDeviceMobile",
          command: (e) => e.setDevice("Mobile portrait"),
          className: "fa fa-mobile",
        },
        {
          id: "PageName",
          label: pageName,
          active: 1,
          command: {
            run: () => {
              setOpenPageName(true);
            },
          },
        },
      ],
    });

    sidebarPannel({ editor, settingSidebarOpen, setSettingSidebarOpen });
    // seoPannel({ editor, page, toast, setUpdateGrapeJs, updateGrapeJs });

    grapeJsEvents(editor);

    utils(editor);
    alignment(editor);
    replaceTextViewComponent(editor);
    setGrapeEditor(editor);
  }, [sendpadForms]);

  useEffect(() => {
    if (grapeEditor) {
      getImages();
    }
  }, [grapeEditor]);

  useEffect(() => {
    if (page) {
      setPageName(page.pag_name);
      setPageTitle(page.pag_title);
      setFaviconUrl(page.pag_favicon);
      setPagSlug(page.pag_slug);
      setBgImageUrl(page.pag_bg_image);
      setPagKeywords(page.pag_keywords);
      setPagDescription(page.pag_description);
      setPagGoogleConversionID(page.pag_googleConversionID);
      setPagGoogleConversionLabel(page.pag_googleConversionLabel);
      setPagGoogleMetaTag(page.pag_googleMetaTag);
      setPagGoogleAnalyticsID(page.pag_googleAnalyticsID);
      setPagMSVerificationTag(page.pag_MSVerificationTag);
      setPagMSUETTagID(page.pag_MSUETTagID);
      setPagCustomHead(page.pag_customHead);
      setPagCustomBody(page.pag_customBody);
      setPagCustomFooter(page.pag_customFooter);
      const pageNameEditor = grapeEditor.Panels.getButton("myNewPanel", "PageName");
      pageNameEditor.set(
        "label",
        ` 
        <span

         class="badge badge-primary" style="cursor: default;">
         
          <span  class="px-2"> ${page.pag_name}   <i class="fa fa-pencil ps-2"> </i></span>
                                 
        </span>
      `
      );
    }
  }, [page]);

  const updateSettings = (seoTitle, seoKeyword, seoDescription, seoSlug) => {
    setIsLoading(true);
    setPageTitle(seoTitle);
    setPagSlug(seoSlug);
    setPagDescription(seoDescription);
    setPagKeywords(seoKeyword);

    options.method = "PUT";
    options.url = `pages`;

    const data = grapeEditor.getProjectData();
    const html = grapeEditor.getHtml();
    const css = grapeEditor.getCss();

    options.data = JSON.stringify({
      pag_id: page.pag_id,
      pag_name: page.pag_name,
      pag_creationDate: page.pag_creationDate,
      pag_status: page.pag_status,
      pag_user_id: page.pag_user_id,
      pag_url: page.pag_url,
      pag_html: html,
      pag_css: css,
      pag_json: JSON.stringify(data),
      pag_version: 1,
      pag_title: seoTitle,
      pag_slug: seoSlug,
      pag_description: seoDescription,
      pag_keywords: seoKeyword,
      pag_favicon: faviconUrl,
      pag_googleConversionID: pagGoogleConversionID,
      pag_googleConversionLabel: pagGoogleConversionLabel,
      pag_googleMetaTag: pagGoogleMetaTag,
      pag_googleAnalyticsID: pagGoogleAnalyticsID,
      pag_MSVerificationTag: pagMSVerificationTag,
      pag_MSUETTagID: pagMSUETTagID,
      pag_customHead: pagCustomHead,
      pag_customBody: pagCustomBody,
      pag_customFooter: pagCustomFooter,
      pag_bgImageURL: bgImageUrl,
    });

    client
      .request(options)
      .then((response) => {
        setIsLoading(false);
        if (response === undefined) {
          setLoadingText("Slug already exists");
        } else {
          setPage(response);
          setOpenSettingSaved(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log("error", error);
      });
  };

  const updateScript = (
    googleConversionId,
    conversionLabel,
    googleMetaTag,
    googleAnalyticsId,
    msSiteVerificationTag,
    msUetTagId,
    headScript,
    bodyScript,
    footerScript
  ) => {
    setIsLoading(true);
    setPagGoogleAnalyticsID(googleAnalyticsId);
    setPagGoogleConversionID(googleConversionId);
    setPagGoogleConversionLabel(conversionLabel);
    setPagGoogleMetaTag(googleMetaTag);
    setPagMSVerificationTag(msSiteVerificationTag);
    setPagMSUETTagID(msUetTagId);
    setPagCustomHead(headScript);
    setPagCustomBody(bodyScript);
    setPagCustomFooter(footerScript);

    options.method = "PUT";
    options.url = `pages`;

    const data = grapeEditor.getProjectData();
    //const html = grapeEditor.Commands.run("gjs-get-inlined-html"); // grapeEditor.getHtml();
    const html = grapeEditor.getHtml();
    const css = grapeEditor.getCss();
    // console.log("pageTitle", title, slug, favicon);

    options.data = JSON.stringify({
      pag_id: page.pag_id,
      pag_name: page.pag_name,
      pag_creationDate: page.pag_creationDate,
      pag_status: page.pag_status,
      pag_user_id: page.pag_user_id,
      pag_url: page.pag_url,
      pag_html: html,
      pag_css: css,
      pag_json: JSON.stringify(data),
      pag_version: 1,
      pag_title: pageTitle,
      pag_slug: pagSlug,
      pag_description: pagDescription,
      pag_keywords: pagKeywords,
      pag_googleConversionID: googleConversionId,
      pag_googleConversionLabel: conversionLabel,
      pag_googleMetaTag: googleMetaTag,
      pag_googleAnalyticsID: googleAnalyticsId,
      pag_MSVerificationTag: msSiteVerificationTag,
      pag_MSUETTagID: msUetTagId,
      pag_customHead: headScript,
      pag_customBody: bodyScript,
      pag_customFooter: footerScript,
      pag_bgImageURL: bgImageUrl,
      pag_favicon: faviconUrl,
    });

    client
      .request(options)
      .then((response) => {
        setIsLoading(false);
        if (response === undefined) {
          setLoadingText("Slug already exists");
        } else {
          setPage(response);
          setOpenSettingSaved(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    if (savingOpen) save();
  }, [savingOpen]);

  useEffect(() => {
    if (publishOpen) {
      const sDomain =
        page?.pag_url != ""
          ? page?.pag_url.includes(process.env.REACT_APP_MAIN_DOMAIN)
            ? process.env.REACT_APP_MAIN_DOMAIN
            : page?.pag_url.split("://")[1].split("/")[0]
          : process.env.REACT_APP_MAIN_DOMAIN;
      setSelectedDomain(sDomain);
      if (!sDomain.includes(process.env.REACT_APP_MAIN_DOMAIN))
        setPublishOnRoot(page?.pag_url.split("/").pop() == sDomain);
    }
  }, [publishOpen]);

  useEffect(() => {
    // if (grapeEditor) console.log(grapeEditor.getDirtyCount());
    if (checkSaving) {
      // console.log("hasChanges", hasChanges);
      if (hasChanges) setOpenConfirmationClose(true);
      else {
        navigate("/pages");
        window.location.reload();
      }
      setCheckSaving(false);
    }
  }, [checkSaving]);

  const renderSnackBar = (
    <MDSnackbar
      color="success"
      icon="save"
      title="Setting saved"
      content=""
      dateTime=""
      open={openSettingSaved}
      onClose={closeSettingSaved}
      close={closeSettingSaved}
      backgroundcolor={"error"}
    />
  );

  const save = () => {
    setIsSaving(true);
    setLoadingText("");
    options.method = "PUT";
    options.url = `pages`;

    const data = grapeEditor.getProjectData();
    //const html = grapeEditor.Commands.run("gjs-get-inlined-html"); // grapeEditor.getHtml();
    const html = grapeEditor.getHtml();
    const css = grapeEditor.getCss();
    // console.log("pageTitle", title, slug, favicon);

    options.data = JSON.stringify({
      pag_id: page.pag_id,
      pag_name: pageName,
      pag_creationDate: page.pag_creationDate,
      pag_status: page.pag_status,
      pag_user_id: page.pag_user_id,
      pag_url: page.pag_url,
      pag_html: html,
      pag_css: css,
      pag_json: JSON.stringify(data),
      pag_version: 1,
      pag_title: pageTitle,
      pag_slug: pagSlug,
      pag_bgImageURL: bgImageUrl,
      pag_favicon: faviconUrl,
      pag_description: pagDescription,
      pag_keywords: pagKeywords,
      pag_googleConversionID: pagGoogleConversionID,
      pag_googleConversionLabel: pagGoogleConversionLabel,
      pag_googleMetaTag: pagGoogleMetaTag,
      pag_googleAnalyticsID: pagGoogleAnalyticsID,
      pag_MSVerificationTag: pagMSVerificationTag,
      pag_MSUETTagID: pagMSUETTagID,
      pag_customHead: pagCustomHead,
      pag_customBody: pagCustomBody,
      pag_customFooter: pagCustomFooter,
    });

    client
      .request(options)
      .then((response) => {
        setSavingOpen(false);
        if (response === undefined) {
          setLoadingText("Slug already exists");
        } else {
          setPage(response);
          const pageNameEditor = grapeEditor.Panels.getButton("myNewPanel", "PageName");
          pageNameEditor.set(
            "label",
            ` 
        <span

         class="badge badge-primary" style="cursor: default;">
         
          <span  class="px-2"> ${response.pag_name}   <i class="fa fa-pencil ps-2"> </i></span>
                                 
        </span>
      `
          );
          // grapeEditor.clearDirtyCount();
          setHasChanges(false);
          setIsSaving(false);
        }
      })
      .catch((error) => {
        // setIsSaving(false);
        console.log(error);
      });
  };

  const publish = () => {
    setIsLoading(true);
    setLoadingText("Publishing...");
    options.method = page == null ? "POST" : "PUT";
    options.url = `pages`;
    const data = grapeEditor.getProjectData();
    //const html = grapeEditor.Commands.run("gjs-get-inlined-html"); // grapeEditor.getHtml();
    const html = grapeEditor.getHtml();
    const css = grapeEditor.getCss();

    options.data = JSON.stringify({
      pag_id: page.pag_id,
      pag_creationDate: page.pag_creationDate,
      pag_status: 0,
      pag_user_id: page.pag_user_id,
      pag_url:
        selectedDomain == process.env.REACT_APP_MAIN_DOMAIN
          ? `https://${account.user_subDomain}.${process.env.REACT_APP_MAIN_DOMAIN}/${pagSlug}`
          : publishOnRoot
          ? `https://${selectedDomain}`
          : `https://${selectedDomain + (pagSlug != "" ? "/" + pagSlug : "")}`,
      pag_html: html,
      pag_css: css,
      pag_json: JSON.stringify(data),
      pag_version: 1,
      pag_title: pageTitle,
      pag_name: pageTitle,
      pag_slug: pagSlug,
      pag_description: pagDescription,
      pag_keywords: pagKeywords,
      pag_googleConversionID: pagGoogleConversionID,
      pag_googleConversionLabel: pagGoogleConversionLabel,
      pag_googleMetaTag: pagGoogleMetaTag,
      pag_googleAnalyticsID: pagGoogleAnalyticsID,
      pag_MSVerificationTag: pagMSVerificationTag,
      pag_MSUETTagID: pagMSUETTagID,
      pag_customHead: pagCustomHead,
      pag_customBody: pagCustomBody,
      pag_customFooter: pagCustomFooter,
      pag_bgImageURL: bgImageUrl,
      pag_favicon: faviconUrl,
    });

    client
      .request(options)
      .then((response) => {
        if (response == "Slug already exists" || response == undefined) {
          if (publishOnRoot) setLoadingText("This domain already contains a page in the root");
          else setLoadingText("Slug already exists");
        } else {
          setPage(response);
          setPublishOpen(false);
          setHasChanges(false);
          navigate("/pages");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getPageById = (id) => {
    options.method = "GET";
    options.url = `pages/byid?page_id=${id}`;
    client
      .request(options)
      .then((response) => {
        setOpenTemplates(false);
        page.pag_json = response.pag_json;
        page.pag_html = response.pag_html;
        page.pag_css = response.pag_css;
        grapeEditor.loadProjectData(JSON.parse(response.pag_json));
        grapeEditor.UndoManager.clear();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changePageName = (value) => {
    setPageName(value);
  };

  return (
    <>
      <ConfirmationAlert
        openModal={OpenConfirmationClose}
        isLoading={isLoading}
        on
        title={"Are you sure you want to close the page? Any unsaved changes will be lost."}
        onYes={() => {
          navigate("/pages");
          window.location.reload();
        }}
        onClose={() => setOpenConfirmationClose(false)}
      />
      <Dialog open={publishOpen} onClose={(e, reason) => reason != "" ?? setOpenTemplates(false)}>
        <Card style={{ padding: 20 }}>
          <CardHeader>Select your destination</CardHeader>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                autofillBackgroundColor="highlight"
                disabled={isLoading}
                variant="outlined"
                defaultValue={
                  page?.pag_url != ""
                    ? page?.pag_url.includes(process.env.REACT_APP_MAIN_DOMAIN)
                      ? process.env.REACT_APP_MAIN_DOMAIN
                      : page?.pag_url.split("://")[1].split("/")[0]
                    : process.env.REACT_APP_MAIN_DOMAIN
                }
                options={domains}
                renderInput={(params) => <MDInput {...params} variant="standard" />}
                fullWidth
                onChange={(e, value) => setSelectedDomain(value)}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={publishOnRoot}
                    onChange={() => setPublishOnRoot(!publishOnRoot)}
                    disabled={selectedDomain == process.env.REACT_APP_MAIN_DOMAIN}
                  />
                }
                label="Publish on root domain"
              />
            </Grid>
            <Grid item xs={12}>
              <MDTypography variant="caption" color="secondary">
                {selectedDomain == process.env.REACT_APP_MAIN_DOMAIN
                  ? `https://${account.user_subDomain}.${process.env.REACT_APP_MAIN_DOMAIN}/${pagSlug}`
                  : publishOnRoot
                  ? `https://${selectedDomain}`
                  : `https://${selectedDomain + (pagSlug != "" ? "/" + pagSlug : "")}`}
              </MDTypography>
            </Grid>
            <Grid item xs={12}>
              {loadingText != "" && (
                <>
                  {loadingText}
                  {isLoading && (
                    <CircularProgress
                      size={30}
                      style={{ marginLeft: 15, position: "relative", top: 4 }}
                    />
                  )}
                </>
              )}
            </Grid>
            <Grid item xs={12}>
              <MDButton
                color="success"
                variant="gradient"
                onClick={publish}
                disabled={isLoading}
                style={{ color: "#FFF", padding: 10 }}
              >
                {draftLoading ? "Loading" : `Publish on selected domain`}
              </MDButton>
              <MDButton
                onClick={() => {
                  setPublishOpen(!publishOpen);
                }}
                variant="outlined"
                color="secondary"
                disabled={isLoading}
                style={{
                  marginLeft: 10,
                }}
              >
                Cancel
              </MDButton>
            </Grid>
          </Grid>
        </Card>
      </Dialog>
      <Dialog open={openPageName}>
        <MDBox
          variant="gradient"
          bgColor="secondary"
          coloredShadow="secondary"
          mt={-1}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h6" fontWeight="medium" color="white">
            Set page name
          </MDTypography>
        </MDBox>
        <DialogContent>
          <MDInput
            autofocus
            type={"text"}
            label="Page Name"
            value={pageName}
            onChange={(e) => changePageName(e.target.value)}
            fullWidth
            style={{ marginBottom: 20 }}
          />
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenPageName(false);
            }}
            variant="outlined"
            color="secondary"
            disabled={isLoading}
          >
            Close
          </MDButton>
          <MDButton
            onClick={() => {
              save();
              setOpenPageName(false);
            }}
            variant="contained"
            color="success"
            disabled={isLoading}
          >
            Change
          </MDButton>
          {isLoading && (
            <CircularProgress size={30} style={{ marginLeft: 15, position: "relative", top: 4 }} />
          )}
        </DialogActions>
      </Dialog>
      <Templates
        open={openTemplates}
        filterPageId={id}
        onClose={() => setOpenTemplates(false)}
        close={() => setOpenTemplates(false)}
        loadTemplate={(json) => {
          grapeEditor.loadProjectData(json);
          grapeEditor.UndoManager.clear();
          setOpenTemplates(false);
        }}
        loadPage={(id) => getPageById(id)}
        fullScreen
      />
      <Dialog
        open={isSaving}
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
        }}
        sx={{
          "& .MuiPaper-root": {
            background: "transparent",
          },
        }}
      >
        <DialogContent>
          {loadingText == "" && <CircularProgress size={60} color="primary" margin="10" />}
          {loadingText != "" && (
            <>
              <MDTypography variant="h6" fontWeight="medium" color="primary">
                {loadingText}
              </MDTypography>
              <MDButton onClick={() => setIsSaving(false)} variant="outlined" color="secondary">
                Close
              </MDButton>
            </>
          )}
        </DialogContent>
      </Dialog>

      <Grid container>
        <Grid item xs={12} md={12}>
          {settingSidebarOpen && (
            <Settingsidebar
              isLoading={isLoading}
              editor={grapeEditor}
              setSettingSidebarOpen={setSettingSidebarOpen}
              initialData={page}
              updatePageSettings={(seoTitle, seoKeyword, seoDescription, seoSlug) =>
                updateSettings(seoTitle, seoKeyword, seoDescription, seoSlug)
              }
              updatePageScripts={(
                googleConversionId,
                conversionLabel,
                googleMetaTag,
                googleAnalyticsId,
                msSiteVerificationTag,
                msUetTagId,
                headScript,
                bodyScript,
                footerScript
              ) =>
                updateScript(
                  googleConversionId,
                  conversionLabel,
                  googleMetaTag,
                  googleAnalyticsId,
                  msSiteVerificationTag,
                  msUetTagId,
                  headScript,
                  bodyScript,
                  footerScript
                )
              }
              updateFavicon={(url) => {
                setFaviconUrl(url);
              }}
              updateBgImage={(url) => {
                setBgImageUrl(url);
              }}
            />
          )}
          <div id="gjs"></div>
        </Grid>
      </Grid>

      {renderSnackBar}
    </>
  );
}
